import Vue from 'vue';
import Component from 'vue-class-component';
import * as i18next from 'i18next';
import router from 'src/router';
import * as api from 'core/api';
import * as auth from 'core/auth';
import * as orders from 'core/orders';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class AccountOrdersComponent extends Vue {
    $auth: auth.AuthService; // Injected in G2S.init

    currentUser: api.UserAccount | null = null;

    view: string = 'loading';

    orders: orders.OrderModel[] = [];

    ordersPageSize: number = 3;
    ordersVisible: number = this.ordersPageSize;

    get pagedOrders(): orders.OrderModel[] {
        return this.orders.slice(0, this.ordersVisible);
    }

    mounted() {
        if (this.$auth.authenticated) {
            this.$auth.GetActiveReservationPublicId().then(
                result => {
                    if (result) {
                        const ct = this.$route.query.ct ? <api.ProductChoiceType>parseInt(<string>this.$route.query.ct) : api.ProductChoiceType.notSet;
                        router.push(`/order/${result}?ct=${ct}`);
                    } else {
                        this.loadModel();
                    }
                },
                () => {
                    this.loadModel();
                }
            );
        } else {
            this.$nextTick(function() {
                const ct = this.$route.query.ct ? <api.ProductChoiceType>parseInt(<string>this.$route.query.ct) : api.ProductChoiceType.notSet;

                if (this.$route.query.token) {
                    // If token in url the try to confirm user
                    this.$auth.confirm(this.$route.query.token as string).then(
                        (result: api.User) => {
                            if (result.hasPassword) {
                                this.loadModel();
                            } else {
                                window.location.href = '/account/sms';
                            }
                        },
                        () => {
                            router.push({
                                path: '/account/sms',
                                query: { redirect: `/account/products/buy?ct=${ct}` }
                            });
                        }
                    );
                } else {
                    router.push({
                        path: '/account/sms',
                        query: { redirect: `/account/products/buy?ct=${ct}` }
                    });
                }
            });
        }
    }

    loadModel() {
        this.$auth.ordersList().then(
            (result: api.ReservationStatusResult[]) => {
                if (result && result.length > 0) {
                    this.view = 'view';
                    this.orders = new orders.OrderService().convertToOrders(result);
                } else {
                    this.view = 'empty';
                }
            },
            (error) => {
                this.view = 'error';

                if (error.response) {
                    console.log('XHR failed', error.response.status, error.response.data);
                } else {
                    console.log('XHR error', error.message);
                }
            }
        );
    }

    onAllOrders() {
        if (this.ordersVisible < this.orders.length) {
            this.ordersVisible = this.orders.length;
        } else {
            this.ordersVisible = this.ordersPageSize;
        }
    }

    getOrderUrl(order: api.ReservationStatusResult) {
        return '/order/' + order.reservationInfo.reservationPublicId;
    }

    getOrderProductsUrl(order: api.ReservationStatusResult) {
        const ct = this.$route.query.ct ? <api.ProductChoiceType>parseInt(<string>this.$route.query.ct) : api.ProductChoiceType.notSet;
        return `/account/products/buy/${order.reservationInfo.reservationPublicId}?ct=${ct}`;
    }

    getOrderNumber(order: api.ReservationStatusResult) {
        return i18next.t('label_with_number', { i: order.reservationInfo.reservationNumber });
    }
}
